import { defineComponent as _defineComponent } from 'vue';
import { ShortcutFilterButtonState } from '../types/shortcutFilterButtonStates';
import { isNullOrEmpty } from 'Js/utils/stringUtils';
import { computed } from 'vue';
import EnItem from 'Components/base/EnItem/EnItem.vue';
import EnBadge from '../../base/EnBadge/EnBadge.vue';
import EnTooltip from 'Components/base/EnTooltip/EnTooltip.vue';
import EnSkeleton from 'Components/base/EnSkeleton/EnSkeleton.vue';
import { buildStaticId } from 'Components/utils/buildStaticId';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnShortcutFilterButton',
    props: {
        /*
         Base key for shortcut button (same idea as filter buttons). Used for id.
         Example: "ArchivedInvoices"
        */
        id: String,
        /*
         State of the button derived from ShortcutFilterButtonState. Can be active, default (inactive), disabled.
        */
        state: ShortcutFilterButtonState,
        /*
         Label of the button
        */
        label: String,
        /*
         Function callback that is used when button becomes active. Typically used to activate the appropriate FilterButton.
        */
        filterCallback: Object,
        /*
         Tooltip text that is displayed when hovering over the button.
        */
        tooltip: String,
        /*
         Hint text that is displayed under the button if active.
        */
        hint: String,
        /**
         * Shows number of filtered elements
         */
        totalCount: Number,
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const buttonKey = ref(0);
        async function onFilterShortcutButtonClick() {
            if (props.state === ShortcutFilterButtonState.Disabled || props.state === ShortcutFilterButtonState.Loading || props.state === ShortcutFilterButtonState.Active)
                return;
            buttonKey.value++;
            count.value = undefined;
            await props.filterCallback.filterCallback();
        }
        const count = ref(undefined);
        // const count = ref(props.totalCount);
        const buttonId = computed(() => {
            return !isNullOrEmpty(props.id) ? buildStaticId('shortcut-button', props.id, true) : 'filter-shortcut-button';
        });
        const itemState = computed(() => props.state || ShortcutFilterButtonState.Default);
        watch(() => props.totalCount, val => {
            // deactivated at the moment
            // count.value = val;
        });
        const __returned__ = { props, buttonKey, onFilterShortcutButtonClick, count, buttonId, itemState, get ShortcutFilterButtonState() { return ShortcutFilterButtonState; }, get isNullOrEmpty() { return isNullOrEmpty; }, EnItem, EnBadge, EnTooltip, EnSkeleton };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
